import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "currentColor",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M2.043 8.374a6.33 6.33 0 0 1 6.333-6.332 6.332 6.332 0 1 1 0 12.664 6.33 6.33 0 0 1-6.333-6.332M8.376.542a7.832 7.832 0 1 0 4.982 13.876l2.82 2.82a.75.75 0 0 0 1.061-1.06l-2.82-2.82A7.832 7.832 0 0 0 8.376.543",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }